/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Name = 'Website.Checkout.Field.Name';
export const Address = 'Website.Checkout.Field.Address';
export const ToggleManualAddress = 'Website.Checkout.Field.ToggleManualAddress';
export const ToggleAutocompleteAddress = 'Website.Checkout.Field.ToggleAutocompleteAddress';
export const ZipCode = 'Website.Checkout.Field.ZipCode';
export const City = 'Website.Checkout.Field.City';
export const Country = 'Website.Checkout.Field.Country';
export const Mobile = 'Website.Checkout.Field.Mobile';
export const Email = 'Website.Checkout.Field.Email';
export const Attention = 'Website.Checkout.Field.Attention';
export const CompanyName = 'Website.Checkout.Field.CompanyName';
export const IAccept = 'Website.Checkout.Field.IAccept';
export const IncludingOrderIsNotBindingUntilConfirmed = 'Website.Checkout.Field.IncludingOrderIsNotBindingUntilConfirmed';
export const GdprInform = 'Website.Checkout.Field.GdprInform';
export const GdprInformEnding = 'Website.Checkout.Field.GdprInformEnding';
export const GdprPolicy = 'Website.Checkout.Field.GdprPolicy';
export const OTCTerms = 'Website.Checkout.Field.OTCTerms';
export const MatasNewsletterSignup = 'Website.Checkout.Field.MatasNewsletterSignup';
export const Explanation = 'Website.Checkout.Field.Explanation';
export const Save = 'Website.Checkout.Field.Save';
export const ButtonSubmit = 'Website.Checkout.Field.ButtonSubmit';
export const ValidationListHeading = 'Website.Checkout.Field.ValidationListHeading';
